import {
  readDefaultManagingBranchFromOnLoadCacheSync,
} from './regBranchOnLoadCache';
import { getOnLoadRegBranchPayloadFromStorage } from './regBranchOnLoadPayload';

const DEFAULT_MANAGING_BRANCH = '';

/**
 * Managing branch for GetKitchensByManagingBranch, GetProductsByManagingBranch, etc.
 * Prefers plaintext value on `regBranchOnLoadCacheV1`, then login/JWT branchName.
 */
export function getManagingBranchNameForApi() {
  const fromOnLoadCache = readDefaultManagingBranchFromOnLoadCacheSync();
  if (fromOnLoadCache) return fromOnLoadCache;

  const fromSession = getOnLoadRegBranchPayloadFromStorage()?.branchName;
  if (fromSession) return fromSession;

  return DEFAULT_MANAGING_BRANCH;
}
